import React from "react";
import { useSelector, useDispatch } from "react-redux";
import type { RootState } from "@store/store";
import InstituteDetailsModal from "@components/InstituteDetails/InstituteDetailsModal";

import { closeModal } from "@store/slices/modalSlice";
import { MODAL_KEYS } from "@constants/global.constants";

const ModalManager: React.FC = () => {
	const dispatch = useDispatch();
	const modalState = useSelector((state: RootState) => state.modal);

	return (
		<>
			{/* Institute Details Modal */}
			<InstituteDetailsModal
				open={modalState.instituteDetailsModal.isOpen}
				onClose={() => dispatch(closeModal(MODAL_KEYS.INSTITUTE_DETAILS))}
			/>
		</>
	);
};

export default ModalManager;
